import React from 'react';
import './GmailMobile.css';

export const GmailMobile = ({product}) => (
    <div className='gmail-mobile'>
        <div className="gmail-mobile__title">{product.title}</div>
        <div className="gmail-mobile__description">{product.description}</div>
    </div>
)